module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.12242/js/img/ServiceHub_Icon.svg"